import { useEffect, useState } from "react";
import { Trophy } from "lucide-react";
import { PageHeader } from "@/components/common/PageHeader";
import { Loader } from "@/components/common/Loader";
import { api } from "@/lib/api";

export default function Career() {
    const [data, setData] = useState(null);
    useEffect(() => { api.get("/career").then(({ data }) => setData(data)); }, []);
    if (!data) return <Loader label="Loading career" />;

    const cats = Object.entries(data.categories || {});

    return (
        <div className="ww-fade-up">
            <PageHeader title="Career Mode" subtitle="Persistent progression across every skill discipline." />

            <div className="bg-surface border border-border rounded-sm p-6 mb-6 flex items-center gap-6 ww-grid-bg">
                <div className="relative">
                    <div className="w-24 h-24 rounded-sm border-2 border-volt/40 bg-volt/5 grid place-items-center">
                        <Trophy className="w-9 h-9 text-volt" />
                    </div>
                </div>
                <div>
                    <div className="text-[11px] uppercase tracking-[0.2em] text-muted-foreground font-semibold">Overall Career Level</div>
                    <div className="font-mono font-bold text-5xl text-white mt-1" data-testid="career-level">{data.overall_level}<span className="text-lg text-muted-foreground">/100</span></div>
                    <p className="text-sm text-muted-foreground mt-1">Keep playing and analyzing matches to level up every discipline.</p>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {cats.map(([key, c]) => (
                    <div key={key} className="bg-surface border border-border rounded-sm p-5" data-testid={`career-${key}`}>
                        <div className="flex items-center justify-between mb-2">
                            <span className="font-heading font-semibold text-white">{c.label}</span>
                            <span className="font-mono text-volt">LVL {c.level}</span>
                        </div>
                        <div className="h-2 bg-obsidian rounded-full overflow-hidden">
                            <div className="h-full bg-gradient-to-r from-volt/70 to-volt rounded-full transition-all duration-700" style={{ width: `${(c.xp / c.xp_to_next) * 100}%` }} />
                        </div>
                        <div className="flex justify-between text-[11px] text-muted-foreground font-mono mt-1.5">
                            <span>{c.xp} / {c.xp_to_next} XP</span>
                            <span>Next: LVL {Math.min(100, c.level + 1)}</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
